import { SegmentGroup } from "@chakra-ui/react";
import * as React from "react";

export interface SegmentedControlItem {
  value: string;
  label: React.ReactNode;
}

interface SegmentedControlProps {
  items: SegmentedControlItem[];
  value: string;
  onValueChange: (value: string) => void;
  /** "chart" uses the narrower 90px tabs from the chart cards. */
  size?: "md" | "chart";
  /** Id of the element naming the group, which renders as a radiogroup. */
  "aria-labelledby"?: string;
}

export function SegmentedControl({
  "aria-labelledby": ariaLabelledBy,
  items,
  onValueChange,
  size = "md",
  value,
}: SegmentedControlProps) {
  return (
    <SegmentGroup.Root
      aria-labelledby={ariaLabelledBy}
      alignSelf="flex-start"
      background="bg.hover"
      borderWidth="0"
      borderRadius="l1"
      height="9"
      padding="1"
      size="sm"
      value={value}
      onValueChange={(e) => e.value && onValueChange(e.value)}
    >
      <SegmentGroup.Indicator
        background="white"
        borderRadius="sm"
        boxShadow="xs"
      />
      {items.map((item) => (
        <SegmentGroup.Item
          key={item.value}
          value={item.value}
          borderRadius="sm"
          color="fg.muted"
          fontFamily="inter"
          fontSize="sm"
          fontWeight="medium"
          height="7"
          justifyContent="center"
          minWidth={size === "chart" ? ("90px" as any) : ("110px" as any)}
          _checked={{ color: "fg.ink" }}
          _hover={{ color: "fg" }}
        >
          <SegmentGroup.ItemText>{item.label}</SegmentGroup.ItemText>
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
      ))}
    </SegmentGroup.Root>
  );
}
